// extracted by mini-css-extract-plugin
export default {"card":"P0-z","carouselContainer":"Q0-z","carouselContent":"R0-z"};